import { motion } from "framer-motion";
import {
  Briefcase,
  Desktop,
  ChatCircleDots,
  ShieldCheck,
  CalendarCheck,
  Cloud
} from "@phosphor-icons/react";

const services = [
  {
    icon: Briefcase,
    title: "Gestion De Projet",
    description: "Vous avez un nouveau projet informatique en tête ? Nous pouvons vous aider à le rationaliser et à l'exécuter avec efficacité et une productivité optimale, dans le respect de vos délais et de votre budget."
  },
  {
    icon: Desktop,
    title: "Fourniture De Matériel",
    description: "Nous vous aidons à choisir les équipements (ordinateurs, TNI, réseaux) offrant le meilleur rapport qualité/prix/durabilité pour un usage intensif en milieu scolaire."
  },
  {
    icon: ChatCircleDots,
    title: "Conseil Achat Stratégique",
    description: "Notre service de Conseil Stratégique est conçu spécifiquement pour vous aider à maximiser chaque euro investi dans la technologie. Optimisation Budgétaire, Alignement Pédagogique et Technologique, Sécurité, Conformité et Pérennité."
  },
  {
    icon: ShieldCheck,
    title: "Cybersécurité",
    description: "Ne traitez pas la cybersécurité comme une dépense, mais comme une assurance essentielle à la continuité de votre mission éducative. Nous vous offrons la tranquillité d'esprit, la protection contre les sanctions légales, et surtout, la garantie que vos données restent sécurisées."
  },
  {
    icon: CalendarCheck,
    title: "Planification De La Reprise Après Un Sinistre",
    description: "Vous souhaitez vous préparer aux incidents futurs ? Vous faites face à une catastrophe d'entreprise ? Nous pouvons vous aider à élaborer un plan de reprise d'activité. Contactez-nous."
  },
  {
    icon: Cloud,
    title: "Cloud",
    description: "Votre établissement génère une quantité critique de données : dossiers élèves, résultats d'examens, contenus pédagogiques, archives administratives. Ces données sont le cœur de votre fonctionnement."
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 }
  }
};

export default function ServicesSection() {
  return (
    <section id="services" className="py-24 sm:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Nos Services
          </h2>
          <p className="text-lg sm:text-xl text-sky-500 font-medium max-w-3xl mx-auto">
            Vaste gamme de services et de solutions informatiques que nous proposons
          </p>
        </div>

        {/* Services Grid */}
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="service-card bg-sky-50/50 border border-slate-200 rounded-2xl p-8 hover:bg-white"
              data-testid={`service-card-${index}`}
            >
              <div className="icon-container mb-6">
                <service.icon size={32} weight="duotone" className="text-sky-500" />
              </div>
              <h3 className="font-['Outfit'] text-xl font-semibold text-sky-600 mb-4">
                {service.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
